// Homepage cinematic header: transparent while it overlays the hero photo, solid once
// the page is scrolled. Toggles `.syv-nav--solid` on #site-nav (styled in site.css).
(function () {
    var nav = document.getElementById('site-nav');
    if (!nav) return;

    var solid = false;
    function onScroll() {
        var next = window.scrollY > 24;
        if (next !== solid) {
            solid = next;
            nav.classList.toggle('syv-nav--solid', solid);
        }
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
})();
